import './external-tools';
import initializeFoundation from './foundation';
import { initializeAnalytics } from './initializeAnalytics';
import initializeRailsFormValidation from './railsFormValidation';
import './setupDatadog';
import './setupHoneybadger';
import initializeStickySidebar from './stickySidebar';
import initializeTooltips from './tooltip';
import './whatInput';
import { onReady } from 'boot/common/domReady';

onReady(initializeAnalytics);

onReady(initializeFoundation);
onReady(initializeStickySidebar);
onReady(initializeTooltips);
onReady(initializeRailsFormValidation);
